import type {ReactNode, RefObject} from 'react'
import {Hero} from '@primer/react-brand/esm'

import type {FlexSuiteBaseHeroProps} from './types'
import {getDescription, getHeading} from './utils'

type HeroContentProps = FlexSuiteBaseHeroProps & {
  'data-testid'?: string
  children?: ReactNode
  className?: string
  imageContainerClassName?: string
  imageContainerRef?: RefObject<HTMLDivElement | null>
  headingClassName?: string
}

export function HeroContent({
  heroHeading,
  heroLabel,
  heroDescription,
  heroCtaOne,
  heroCtaTwo,
  heroTertiaryDescription,
  options,
  children,
  className,
  'data-testid': dataTestId,
  imageContainerClassName,
  imageContainerRef,
  headingClassName,
}: HeroContentProps) {
  const {variant, enableAnimation, align, textVariant} = options
  const trailingComponent = heroTertiaryDescription
    ? () => getDescription(heroTertiaryDescription, textVariant)
    : undefined

  return (
    <Hero
      className={className}
      variant={variant}
      align={align}
      enableAnimation={enableAnimation}
      trailingComponent={trailingComponent}
      data-testid={dataTestId}
      imageContainerClassName={imageContainerClassName}
      imageContainerRef={imageContainerRef}
    >
      {heroLabel && <Hero.Label>{heroLabel}</Hero.Label>}
      <Hero.Heading className={headingClassName}>{getHeading(heroHeading)}</Hero.Heading>
      {heroDescription ? (
        <Hero.Description variant={textVariant}>{getDescription(heroDescription, textVariant)}</Hero.Description>
      ) : null}
      <Hero.PrimaryAction href={heroCtaOne.fields.href}>{heroCtaOne.fields.text}</Hero.PrimaryAction>
      {heroCtaTwo && (
        <Hero.SecondaryAction href={heroCtaTwo.fields.href}>{heroCtaTwo.fields.text}</Hero.SecondaryAction>
      )}
      {children}
    </Hero>
  )
}
